module.exports = __webpack_public_path__ + "public/img/preview-exam.13ce321c.png";